import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 14.997v-6m-1.5 0h3M12 9v4.5a1.5 1.5 0 0 0 1.5 1.5H15m-9 0v-4.5a1.5 1.5 0 0 1 3 0V15m-3-3.003h3"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5 1.497h15s3 0 3 3v15s0 3-3 3h-15s-3 0-3-3v-15s0-3 3-3"
    }, null, -1)
  ]));
}
const computerKeyboardAlt = { render };
export {
  computerKeyboardAlt as default,
  render
};
//# sourceMappingURL=computer-keyboard-alt.svg.js.map
